<template>
  <Form ref="form" @submit="onSubmit">
    <div class="modal-header">
      <h4 class="modal-title">Crear Disposición</h4>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="row card-body">
        <div class="col-sm-6 text-right">
          <PrimaryButton class="btn btn-success" @click.prevent="openTable(2)"><i class="fa fa-search"></i>Seleccionar
            Prospecto</PrimaryButton>
        </div>
        <div class="col-sm-6 text-left">
          <PrimaryButton v-if="enableLoanApplicationsBtn" class="btn btn-success" @click.prevent="openTable(3)"><i
              class="fa fa-search"></i>Seleccionar Solicitud</PrimaryButton>
        </div>
        <div class="form-group col-sm-12">
          <label for="ProspectFullname">Prospecto:</label>
          <Field v-model="getProspectusFullname" type="text" class="form-control col-sm-9" name="ProspectFullname"
            disabled />
        </div>
        <div class="form-group col-sm-6">
          <label for="address">Domicilio:</label>
          <Field v-model="getProspectusAddress" type="text" class="form-control col-sm-9" name="prospectusAddress"
            disabled />
        </div>
        <div class="form-group col-sm-6">
          <label for="productTypeId">Tipo de Producto:</label>
          <Field v-model="productTypeName" type="text" class="form-control col-sm-9" name="productTypeId" disabled />
        </div>
        <div class="form-group col-sm-6">
          <label for="DisbursementDate">Fecha de Disposición:</label>
          <Field v-model="dateDistribution" type="text" class="form-control col-sm-9" name="DisbursementDate"
            disabled />
        </div>
        <div class="form-group col-sm-6">
          <label for="authorizedAmount">Monto autorizado:</label>
          <Field v-model="creditAmount" type="text" class="form-control col-sm-9" name="authorizedAmount" disabled />
        </div>
        <div class="col-sm-12">
          <label for="bank">Datos bancarios:</label>
        </div>
        <div class="form-group col-sm-6">
          <label for="accountHoldersName">Nombre de titular:</label>
          <Field v-model="directDebitAccountHoldersName" type="text" class="form-control col-sm-9"
            name="accountHoldersName" disabled />
        </div>
        <div class="form-group col-sm-6">
          <label for="bankAccount">Número de cuenta:</label>
          <Field v-model="directDebitBankAccount" type="text" class="form-control col-sm-9" name="bankAccount"
            disabled />
        </div>
        <div class="form-group col-sm-6">
          <label for="clabe">CLABE Interbancaria:</label>
          <Field v-model="directDebitClabe" type="text" class="form-control col-sm-9" name="clabe" disabled />
        </div>
        <div class="form-group col-sm-6">
          <label for="bankName">Nombre del banco:</label>
          <Field v-model="directDebitNameBank" type="text" class="form-control col-sm-9" name="bankName" disabled />
        </div>
        <div class="form-group col-sm-6">
          <label :for="'exampleInputFile'">Cargar comprobante de la transeferencia:</label>
          <div class="input-group">
            <label>
              <input type="file" ref="fileInputs" class="" :id="'exampleInputFile'"
                accept=".jpg, .jpeg, .png, .gif, .pdf" @change="handleFileChange($event)" />
              <span class="file-custom"></span>
            </label>
            <label class="custom-file-label" for="exampleInputFile">
              {{ selectedFile ? selectedFile.name : 'Seleccionar archivo' }}
            </label>
          </div>
        </div>
        <!-- Apartado de las 3 validaciones de Operativo / Legal / PLD. Inicialmente debe de estar en tachitas, y cuando cada sección haya validado su parte, debe cambiar a palomitas -->
        <div class="form-group col-sm-12">
          <ul class="list-unstyled">
            <li>
              <label for="operationalValidation">Validación Operativa:</label>
              <i v-if="flowStatusAuthorizationOperative === 1" class="fa fa-check text-success"></i>
              <i v-else class="fa fa-times text-danger"></i>
            </li>
            <li>
              <label for="legalValidation">Validación Legal:</label>
              <i v-if="flowStatusAuthorizationLegal === 1" class="fa fa-check text-success"></i>
              <i v-else class="fa fa-times text-danger"></i>
            </li>
            <li>
              <label for="pldValidation">Validación PLD:</label>
              <i v-if="flowStatusAuthorizationAml === 1" class="fa fa-check text-success"></i>
              <i v-else class="fa fa-times text-danger"></i>
            </li>
          </ul>
        </div>
        <!-- El estatus debe de aparecer en automático -->
        <!-- 1. Completado ( 3 palomitas) / 2. En proceso ( No ha completado las 3 palomitas) 3. No aprobado (Viene de la sección de Calificación). "Perfil de riesgo" -->
        <div class="form-group col-sm-12">
          <label for="statusId">Estatus:</label>
          <StatusSelect v-model="selectedStatusId" :name="'statusId'" :options="statusOptions" :isDisabled="isDisabled">
          </StatusSelect>
        </div>
      </div>
    </div>
    <div class="modal-footer justify-content-between">
      <button type="button" class="btn btn-secondary" data-dismiss="modal">
        {{ cancelButton }}
      </button>
      <PrimaryButton class="btn btn-primary" type="submit" :disabled="isDisabledCreate"><!--:disabled="isDisabledCreate"-->
        {{ createButton }}
      </PrimaryButton>
    </div>
  </Form>
</template>

<script>
import * as helper from '@/helpers';
import { getCurrentInstance } from "vue";
import { mapState, mapActions } from "pinia";
import { useStatusStore } from '@/pinia/status.module';
import { useToast } from 'vue-toast-notification';
import { getLocaleMessage } from '@/services/MessagesService';
import { useIndividualLoanApplicationStore } from '@/pinia/LoanApplications/individual.module';
import { useCorpLoanApplicationStore } from '@/pinia/LoanApplications/corporate.module';
import { sharedStore } from "@/pinia/sharedStore.module";

import PrimaryButton from "@/Components/PrimaryButton.vue";
import StatusSelect from "@/Components/Selects/SelectField.vue";
import Prospectus from "@/Models/Prospects";
import LoanApplication from '@/Models/LoanApplications/LoanApplication';
import { useCreditFacilities } from '@/pinia/creditFacilities.module';
import { useAuthStore } from '@/pinia/auth.module';

export default {
  components: {
    PrimaryButton,
    StatusSelect,
  },
  setup() {
    // Crear la instancia del toast aquí
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      isDisabled: true,
      isDisabledCreate: true,
      status: [
        { id: 23, name: 'Completado' },
        { id: 24, name: 'En proceso' },
        { id: 25, name: 'No aprobado' },
      ],
      dataValues: {},
      selectedFile: null
    }
  },
  emits: ['close-modal', 'show-table'],
  props: {
    prospectus: {
      type: Object,
      default: () => new Prospectus({}),
    },
    loanApplication: {
      type: Object,
      default: () => new LoanApplication({}),
    },
    tempValues: {
      type: Object,
      default: () => { },
    },
  },
  computed: {
    ...mapState(useStatusStore, ['getAllStatusByType', 'getSelectedStatus']),
    ...mapState(sharedStore, ['getProspectus', 'getProspectusFullname', 'getProspectusAddress']),
    cancelButton() {
      return this.$getLocaleMessage('buttons', 'cancel');
    },
    createButton() {
      return this.$getLocaleMessage('buttons', 'create');
    },
    statusOptions() {
      // return (this.getAllStatusByType(4)) ? helper.mapOptions(this.getAllStatusByType(4)) : [];
      return helper.mapOptions(this.status);
    },
    prospectusIsSelected() {
      return this.prospectus.prospectusId != null && this.prospectus.prospectusId !== 0;
    },
    enableLoanApplicationsBtn() {
      return this.prospectusIsSelected;
    },
    getProspectusAddress() {
      if (this.prospectus.personTypeId !== null) {
        const { fiscalAddress } = this.prospectus;
        return `${fiscalAddress.street} ${fiscalAddress.interiorNumber} ${fiscalAddress.exteriorNumber} ${fiscalAddress.exteriorNumber}  ${fiscalAddress.district}`;
      } else {
        return '';
      }
    },
    /**Data de solicitud */
    selectedLoanApplication() {
      return this.loanApplication.id;
    },
    productTypeName() {
      return this.loanApplication?.quotation?.product?.productType?.name || '';
    },
    dateDistribution() {
      const originalDate = this.loanApplication?.quotation?.disbursementDate || '';
      return this.$filters?.formattedDateDistribution(originalDate) || '';
    },
    creditAmount() {
      return this.$filters?.formatNumber(this.loanApplication?.quotation?.creditAmount) || '';
    },
    directDebitNameBank() {
      return this.loanApplication?.directDebit?.bank || '';
    },
    directDebitAccountHoldersName() {
      return this.loanApplication?.directDebit?.authorizedPersonName || '';
    },
    directDebitBankAccount() {
      return this.loanApplication?.directDebit?.accountNumber || '';
    },
    directDebitClabe() {
      return this.loanApplication?.directDebit?.clabe || '';
    },
    flowStatusAuthorizationOperative() {
      console.log("REVISANDO EL RESULTADO flowStatusAuthorizationOperative: ", this.loanApplication);
      return this.loanApplication?.flowStatus?.operational || 0;
    },
    flowStatusAuthorizationLegal() {
      console.log("REVISANDO EL RESULTADO flowStatusAuthorizationLegal: ", this.loanApplication);
      return this.loanApplication?.flowStatus?.legal || 0;
    },
    flowStatusAuthorizationAml() {

      if (this.loanApplication?.creditScore?.creditProfiles?.remarks === "No aprobado" || this.loanApplication?.creditScore?.creditProfiles?.name === "Alto") {
        this.toast.error(getLocaleMessage('creditFacilitiesRequest', 'notApproved'));
      }

      // console.log("REVISANDO EL RESULTADO flowStatusAuthorizationAml: ", this.loanApplication);

      return this.loanApplication?.flowStatus?.aml || 0;
    },
    selectedStatusId() {
      if (!this.loanApplication || !this.loanApplication.flowStatus) {
        this.isDisabledCreate = true;
        return null;
      }

      const { operational, legal, aml } = this.loanApplication.flowStatus;

      // Validar que los valores sean 0 o 1
      const isValidValue = (val) => val === 0 || val === 1;
      if (!isValidValue(operational) || !isValidValue(legal) || !isValidValue(aml)) {
        this.isDisabledCreate = true;
        return null;
      }

      // 1. Condición de "No aprobado" (prioridad máxima cuando aml = 1)
      if (aml === 1) {
        try {
          const creditProfile = this.loanApplication?.creditScore?.creditProfiles;
          if (creditProfile) {
            const isHighRisk = creditProfile.name === "Alto";
            const isNotApproved = creditProfile.remarks === "No aprobado";
            
            if (isHighRisk || isNotApproved) {
              this.isDisabledCreate = true;
              const noAprobado = this.status.find(item => item.name === 'No aprobado');
              return noAprobado ? noAprobado.id : null;
            }
          }
        } catch (error) {
          console.warn('Error al verificar perfil de crédito:', error);
        }
      }

      // 2. Completado (todos en true)
      if (operational === 1 && legal === 1 && aml === 1) {
        this.isDisabledCreate = false;
        const completado = this.status.find(item => item.name === 'Completado');
        return completado ? completado.id : null;
      }

      // 3. Cualquier otra combinación es "En proceso"
      this.isDisabledCreate = true;
      const enProceso = this.status.find(item => item.name === 'En proceso');
      return enProceso ? enProceso.id : null;
    }
  },
  methods: {
    ...mapActions(useIndividualLoanApplicationStore, ['fetchIndividualLoanApplicationsByProspectusId']),
    ...mapActions(useCorpLoanApplicationStore, ['fetchCorpLoanApplicationsByProspectusId']),
    ...mapActions(useCreditFacilities, ['fetchCreditFacilities', 'createCreditFacility']),
    openTable(number) {
      this.dataValues.contentNumber = number;
      this.$emit('show-table', this.dataValues);
    },
    async onSubmit() {
      try {

        // Zona de valdiaciones: Validar que haya un archivo seleccionado
        if (!this.selectedFile) {
          this.toast.error(getLocaleMessage('creditFacilitiesRequest', 'docNoDowload'));
          return;
        }

        //Descomentar si piden estas validaciones si no lo ocupamos se puden eliminar
        /* let findStatus = this.status.find(item => item.id === this.selectedStatusId);

        if(findStatus.name === 'En proceso'){
          this.toast.error(getLocaleMessage('creditFacilitiesRequest', 'pendingAuthorization'));
          return;
        }

        if(findStatus.name === 'No aprobado'){
          this.toast.error(getLocaleMessage('creditFacilitiesRequest', 'notApproved'));
          return;
        } */

        // Crear FormData para enviar archivos
        const formData = new FormData();

        // Agregar el archivo
        formData.append('ReceiptPaymentFiles.File', this.selectedFile);

        // Agregar los otros campos
        formData.append('ProspectusId', this.prospectus.prospectusId);
        formData.append('LoanApplicationId', this.loanApplication.id);
        formData.append('StatusId', this.selectedStatusId);
        formData.append('CompanyId', useAuthStore().user.companyId);
        formData.append('ReceiptPaymentFiles.Version', '1');

        // Campos opcionales (pueden ir vacíos)
        formData.append('ReceiptPaymentFiles.Size', '');
        formData.append('ReceiptPaymentFiles.FilePath', '');
        formData.append('ReceiptPaymentFiles.Name', '');
        formData.append('ReferenceNumber', '');
        formData.append('ReceiptPaymentFiles.GuidName', '');
        formData.append('ReceiptPaymentFiles.FileType', '');

        let response = await this.createCreditFacility(formData);

        //Si el response es satisfactorio entonces
        if (response && response.status) {
          //Refrescamos el contenido de la tabla
          this.fetchCreditFacilities();
          //Reseteamos el formulario    
          this.$refs.form.resetForm();
          //Lipiamos y cerramos lo del formulario de la modal de agregar
          this.resetFileInput();
          this.closeModal();
        }
      } catch (error) {
        this.toast.error(getLocaleMessage('creditFacilitiesRequest', 'errorForm'));
      }
    },
    closeModal() {
      this.$emit('close-modal', true);
    },
    async handleFileChange(event) {
      const fileInput = event.target;

      if (fileInput.files.length > 0) {
        this.selectedFile = fileInput.files[0];

        // Validar tipo de archivo
        const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/gif'];
        if (!allowedTypes.includes(this.selectedFile.type)) {
          this.toast.error(getLocaleMessage('creditFacilitiesRequest', 'typeDoc'));
          this.resetFileInput();
          return;
        }

        // Validar tamaño (ejemplo: máximo 5MB)
        const maxSize = 5 * 1024 * 1024; // 5MB
        if (this.selectedFile.size > maxSize) {
          this.toast.error(getLocaleMessage('creditFacilitiesRequest', 'sizeFile'));
          this.resetFileInput();
          return;
        }

        // Cambiar info por success o show
        this.toast.success(`${getLocaleMessage('creditFacilitiesRequest', 'selectFileSuccess')}: ${this.selectedFile.name}`);
      } else {
        this.selectedFile = null;
        console.log('No se seleccionó ningún archivo');
      }
    },
    // Método para obtener la extensión del archivo
    getFileExtension(filename) {
      return filename.split('.').pop().toLowerCase();
    },
    // Método para resetear el file input
    resetFileInput() {
      this.selectedFile = null;
      if (this.$refs.fileInputs) {
        this.$refs.fileInputs.value = '';
      }
    }

  },
  watch: {
    getProspectus: {
      handler(newProspectus) {
        if (newProspectus != undefined && newProspectus != null && newProspectus.prospectusId != 0) {
          if (newProspectus.personTypeId == 1) {
            //Solo se mostrara las solicitudes que han sido aprobadas
            this.fetchIndividualLoanApplicationsByProspectusId(newProspectus.prospectusId);
          } else {
            //Solo se mostrara las solicitudes que han sido aprobadas
            this.fetchCorpLoanApplicationsByProspectusId(newProspectus.prospectusId);
          }
        }
      },
      immediate: true,
    }
  }
}
</script>